import { Component } from '@angular/core';
import { WidgetsModule } from '../../widgets/widgets.module';

@Component({
  selector: 'app-review-complete-screen',
  imports: [WidgetsModule],
  templateUrl: './review-complete-screen.component.html',
  styleUrls: ['./review-complete-screen.component.scss'],
})
export class ReviewCompleteScreenComponent {}
// TODO: PAGE NOT IN USE YET
